module.exports = __webpack_public_path__ + "img/mobile/Menus-paytable/12@2x.png?0.0.53";